/*
 * Native \"Apply Discount Code\" field for the cart (page + drawer).
 *
 * Applies / removes codes via the Cart Ajax API's `discount` parameter and
 * refreshes IN PLACE through the shared, surface-aware window.arCartMutate()
 * -- works in both the cart drawer and the /cart page, no full reload. Falls
 * back to opening the cart page only if a response can't be used.
 */
class CartDiscountCode extends HTMLElement {
  rootBase() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
    return root;
  }

  get updateUrl() {
    var fromAttr = this.dataset.cartUpdateUrl;
    if (fromAttr) return fromAttr;
    return this.rootBase() + '/cart/update';
  }

  connectedCallback() {
    this.cartUpdateUrl = this.updateUrl;

    this.inner = this.querySelector('[data-discount-inner]');
    this.appliedCodes = ((this.inner && this.inner.dataset.appliedCodes) || '')
      .split(',')
      .map(code => code.trim())
      .filter(Boolean);

    this.input = this.querySelector('[data-discount-input]');
    this.applyBtn = this.querySelector('[data-discount-apply]');
    this.messageEl = this.querySelector('[data-discount-message]');

    if (this.applyBtn) {
      this.applyBtn.addEventListener('click', event => {
        event.preventDefault();
        this.applyCode();
      });
    }

    if (this.input) {
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.applyCode();
        }
      });
    }

    this.querySelectorAll('[data-remove-code]').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        this.removeCode(button.dataset.removeCode);
      });
    });
  }

  setLoading(isLoading) {
    if (this.applyBtn) {
      this.applyBtn.disabled = isLoading;
      this.applyBtn.classList.toggle('is-loading', isLoading);
    }
    if (this.input) this.input.disabled = isLoading;
  }

  showMessage(text, isError) {
    if (!this.messageEl) return;
    if (!text) {
      this.messageEl.hidden = true;
      this.messageEl.textContent = '';
      return;
    }
    this.messageEl.hidden = false;
    this.messageEl.textContent = text;
    this.messageEl.classList.toggle('cart-discount-code__message--error', !!isError);
  }

  applyCode() {
    var raw = ((this.input && this.input.value) || '').trim();
    if (!raw) return;

    var alreadyApplied = this.appliedCodes.some(
      code => code.toLowerCase() === raw.toLowerCase()
    );
    if (alreadyApplied) {
      this.showMessage('That code is already applied.', true);
      return;
    }

    this.submitCodes(this.appliedCodes.concat([raw]));
  }

  removeCode(code) {
    if (!code) return;
    this.submitCodes(
      this.appliedCodes.filter(
        existing => existing.toLowerCase() !== String(code).toLowerCase()
      )
    );
  }

  submitCodes(codes) {
    this.setLoading(true);
    this.showMessage('');

    if (typeof window.arCartMutate === 'function' && window.arCartSurface && window.arCartSurface()) {
      window.arCartMutate(this.cartUpdateUrl, { discount: codes.join(',') });
      return;
    }

    // Fallback: POST then open the cart page.
    fetch(this.cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    })
      .then(function () { window.arGoToCart(); })
      .catch(function () { window.arGoToCart(); });
  }
}

if (!customElements.get('cart-discount-code')) {
  customElements.define('cart-discount-code', CartDiscountCode);
}